export default "__VITE_ASSET__d7f98406__"